import { Component, inject } from '@angular/core';

import { DynamicComponentDirective, MediaQueryService } from '@frontend/vanilla/core';
import { HeaderBarComponent } from '@frontend/vanilla/features/header-bar';
import { AccountMenuConfig } from '@frontend/vanilla/shared/account-menu';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [HeaderBarComponent, DynamicComponentDirective],
    selector: 'vn-am-main-layout',
    templateUrl: 'main-layout.html',
})
export class MainLayoutComponent extends AccountMenuItemBase {
    media = inject(MediaQueryService);
    config = inject(AccountMenuConfig);

    close() {
        this.accountMenuService.toggle(false, {
            closedWithButton: true,
        });
    }
}
